import postalCodeDict from '../assets/data/postalCodeDict.json';

//action
export const SELECT_FIRST = 'SELECT_FIRST';
export const SELECT_SECOND = 'SELECT_SECOND';
export const SET_POSTALVALUE_FIRST = 'SET_POSTALVALUE_FIRST';
export const SET_POSTALVALUE_SECOND = 'SET_POSTALVALUE_SECOND';
export const SET_POSTALINFO = 'SET_POSTALINFO';

export const selectFirst = selected => ({
  type: SELECT_FIRST,
  selected,
});

export const selectSecond = selected => ({
  type: SELECT_SECOND,
  selected,
});

export const setPostalValueFirst = value => ({
  type: SET_POSTALVALUE_FIRST,
  value,
});

export const setPostalValueSecond = value => ({
  type: SET_POSTALVALUE_SECOND,
  value,
});

export const setPostalInfo = postalCode => ({
  type: SET_POSTALINFO,
  postalCode,
});

//reducer
const initialState = {
  selectedFirst: [],
  selectedSecond: [],
  postalValueFirst: '',
  postalValueSecond: '',
  postalCode: null,
  postalInfo: null,
};

const reducer = (state = initialState, action) => {
  switch(action.type) {
    case SELECT_FIRST:
      return {
        ...state,
        selectedFirst: [ action.selected ],
      };
    case SELECT_SECOND:
      return {
        ...state,
        selectedSecond: [ action.selected ],
      };
    case SET_POSTALVALUE_FIRST:
      return {
        ...state,
        postalValueFirst: action.value,
      };
    case SET_POSTALVALUE_SECOND:
      return {
        ...state,
        postalValueSecond: action.value,
      };
    case SET_POSTALINFO:
      const { postalCode } = action;
      const postalInfo = postalCodeDict[`${postalCode}`];
      return {
        ...state,
        postalCode,
        postalInfo,
      };
    default:
      return state;
  }
};

export default reducer;
